module.exports = __webpack_public_path__ + "img/dpd.81e1124a.png";